import { sendVisitorAllocatedVariations as webSendVisitorAllocatedVariations, sendVisitorExposedVariations as webSendVisitorExposedVariations, sendFsHitToQA as webSendFsHitToQA } from '../web/messages/index';
import { sendVisitorAllocatedVariations as mobileSendVisitorAllocatedVariations, sendVisitorExposedVariations as mobileSendVisitorExposedVariations, sendFsHitToQA as mobileSendFsHitToQA } from '../mobile/handleSdkMessage';
export function sendVisitorAllocatedVariations(visitorVariationState) {
    if (__fsWebpackIsBrowser__) {
        webSendVisitorAllocatedVariations(visitorVariationState);
    }
    if (__fsWebpackIsReactNative__) {
        mobileSendVisitorAllocatedVariations(visitorVariationState);
    }
}
export function sendVisitorExposedVariations(visitorVariationState) {
    if (__fsWebpackIsBrowser__) {
        webSendVisitorExposedVariations(visitorVariationState);
    }
    if (__fsWebpackIsReactNative__) {
        mobileSendVisitorExposedVariations(visitorVariationState);
    }
}
export function sendFsHitToQA(hit) {
    if (__fsWebpackIsBrowser__) {
        webSendFsHitToQA(hit);
    }
    if (__fsWebpackIsReactNative__) {
        mobileSendFsHitToQA(hit);
    }
}
